import React, { createContext, useState, useContext } from 'react';
import {CALENDAR_TYPE} from './services/const'
const initialState = {
  authLevel:4,
  city:'Stockholm',
  region:'Stockholm',
  country:'Sverige',
  calendarType:CALENDAR_TYPE.REGULAR
};

const useMyState = () => useState(initialState);

const MyContext = createContext(null);

export const useSharedState = () => {
  const value = useContext(MyContext);
  if (value === null) throw new Error('Please add SharedStateProvider');
  return value;
};

export const SharedStateProvider = ({ children }) => (
  <MyContext.Provider value={useMyState()}>
    {children}
  </MyContext.Provider>
);

